import React, { useState, useEffect } from 'react'

import { AssociationFragmentFragment, useGetAssociationsForFrontendQuery } from '@/packages/associations/gql/Associations.generated'

import AssociationsOverview from './AssociationsOverview'

export default function AssociationsOverviewData() {
  const {
    data: dataAssociations,
    loading: loadingAssociations,
    error: errorAssociations,
  } = useGetAssociationsForFrontendQuery({
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (errorAssociations) {
      // eslint-disable-next-line no-console
      console.error(errorAssociations?.message || '')
    }
  }, [errorAssociations])

  return (
    <AssociationsOverview
      dataAssociations={dataAssociations}
      loading={loadingAssociations}
    />
  )
}
